import { observeElementRect } from '../../rect/dist/index.module.js';
import * as React from 'react';

function useRect(e){const[o,c]=React.useState();return React.useEffect((()=>{if(e){const r=observeElementRect(e,c);return ()=>{c(void 0),r();}}}),[e]),o}

export { useRect };
